import { ProductDetailsService } from '@product-details/services/product-details.service';
import {
  GACompleteOrderDeliveryStep,
  GACompleteOrderPaymentStep,
  GACompleteOrderDirectDebitStep,
} from '@analytics/classes/ga.complete.class';
import { CompleteOrderService } from '@complete-order/services/complete-order.service';
import { ViewOffersService } from '@view-offers/services/view-offers.service';
import { AnalyticsService } from '@analytics/services/analytics.service';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as fromAnalytics from '../actions';
import { tap, withLatestFrom } from 'rxjs/operators';

@Injectable()
export class GACompleteOrderEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly analyticsService: AnalyticsService,
    private readonly viewOffersService: ViewOffersService,
    private readonly productDetailsService: ProductDetailsService,
    private readonly completeOrderService: CompleteOrderService
  ) {}

  DeliveryStep$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromAnalytics.CompleteOrderLoadDeliveryStep),
        withLatestFrom(
          this.viewOffersService.offers$,
          this.productDetailsService.selected$,
          this.completeOrderService.upfrontPayment$,
          this.completeOrderService.formData$
        ),
        tap(([, offers, selected, upfrontPayment, form]) => {
          const gaData = new GACompleteOrderDeliveryStep(
            offers,
            selected,
            upfrontPayment,
            form?.delivery?.expectedDate
          ).gaData;

          this.analyticsService.eventEmitter(gaData);
        })
      ),
    { dispatch: false }
  );

  DirectDebitStep$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromAnalytics.CompleteOrderLoadDirectDebitStep),
        withLatestFrom(
          this.viewOffersService.offers$,
          this.productDetailsService.selected$,
          this.completeOrderService.upfrontPayment$,
          this.completeOrderService.formData$
        ),
        tap(([, offers, selected, upfrontPayment, form]) => {
          const gaData = new GACompleteOrderDirectDebitStep(
            offers,
            selected,
            upfrontPayment,
            form?.delivery?.expectedDate
          ).gaData;
          this.analyticsService.eventEmitter(gaData);
        })
      ),
    { dispatch: false }
  );

  PaymentStep$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromAnalytics.CompleteOrderLoadPaymentStep),
        withLatestFrom(
          this.viewOffersService.offers$,
          this.productDetailsService.selected$,
          this.completeOrderService.upfrontPayment$,
          this.completeOrderService.formData$
        ),
        tap(([, offers, selected, upfrontPayment, form]) => {
          const gaData = new GACompleteOrderPaymentStep(
            offers,
            selected,
            upfrontPayment,
            form?.delivery?.expectedDate
          ).gaData;
          this.analyticsService.eventEmitter(gaData);
        })
      ),
    { dispatch: false }
  );
}
